import React, { useState, useEffect } from 'react';
import {
  TextField,
  Stack
} from '@mui/material';
import Modal from './Modal';
import FormGroup from './FormGroup';
import Button from './Button';
import Alert from './Alert';
import api from '../services/api';

function EditRuleModal({ isOpen, onClose, onRuleUpdated, rule }) {
  const [ruleText, setRuleText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (rule) {
      setRuleText(rule.rule_text);
    }
  }, [rule]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    setSuccess(false);

    try {
      const updateData = {
        rule_text: ruleText
        // updated_by is now auto-filled from authenticated session
      };

      await api.updateRule(rule.id, updateData);
      setSuccess(true);
      setTimeout(() => {
        onRuleUpdated();
      }, 1000);
    } catch (err) {
      setError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Rule">
      <form onSubmit={handleSubmit}>
        {error && <Alert variant="error">{error}</Alert>}
        {success && <Alert variant="success">Rule updated successfully!</Alert>}
        
        <FormGroup label="Rule Scope">
          <TextField
            fullWidth
            value={rule?.rule_scope === 'global' ? 'Global' : `Attribute-Specific (${rule?.attribute_type})`}
            disabled
          />
        </FormGroup>

        <FormGroup label="Page Type">
          <TextField
            fullWidth
            value={rule?.page_type === 'search' ? 'Search Page' : 'Detail Page'}
            disabled
          />
        </FormGroup>

        <FormGroup label="Rule Text" required>
          <TextField
            multiline
            rows={4}
            fullWidth
            value={ruleText}
            onChange={(e) => setRuleText(e.target.value)}
            placeholder="Enter the rule..."
            required
          />
        </FormGroup>

        <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-6">
          <Button variant="outlined" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button type="submit" disabled={submitting}>
            {submitting ? 'Updating...' : 'Update Rule'}
          </Button>
        </Stack>
      </form>
    </Modal>
  );
}

export default EditRuleModal;

